import { useCallback, useEffect, useState } from "react"

export const useLoadImage = (linkImage: string) => {
  const [loading, setLoading] = useState(true)

  const [errorOccurred, setHasErrorLoaded] = useState(linkImage.length > 0 ? false : true)

  useEffect(() => {
    setLoading(linkImage.length > 0)
    
    setHasErrorLoaded(linkImage.length === 0)
  }, [linkImage])

  const handleLoad = useCallback(() => {
    setLoading(false)
  }, [])

  const handleErrorLoad = useCallback(() => {
    setHasErrorLoaded(true)
    
    handleLoad()
  }, [handleLoad])

  return {
    loading,
    errorOccurred,
    handleErrorLoad,
    handleLoad,
  }
}
